import type { LucideIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '@/utils/cn'

export function SectionCard({
  title,
  subtitle,
  count,
  actions,
  children,
  className,
  bodyClassName,
  variant = 'default',
}: {
  title: string
  subtitle?: string
  count?: number
  actions?: ReactNode
  children: ReactNode
  className?: string
  bodyClassName?: string
  /** table = flush body for nested tables; flush = no body padding */
  variant?: 'default' | 'table' | 'flush'
}) {
  return (
    <section className={cn('leap-section', className)}>
      <div className="leap-section__header">
        <div className="min-w-0">
          <div className="leap-section__title">
            {title}
            {typeof count === 'number' ? (
              <span className="leap-section__count">{count}</span>
            ) : null}
          </div>
          {subtitle ? <div className="leap-section__subtitle">{subtitle}</div> : null}
        </div>
        {actions ? <div className="leap-section__actions">{actions}</div> : null}
      </div>
      <div
        className={cn(
          'leap-section__body',
          variant === 'table' || variant === 'flush' ? 'leap-section__body--flush' : null,
          bodyClassName
        )}
      >
        {children}
      </div>
    </section>
  )
}

export function DetailPane({
  title,
  subtitle,
  icon: Icon,
  children,
}: {
  title: string
  subtitle?: string
  icon: LucideIcon
  children: ReactNode
}) {
  return (
    <div className="detail-pane">
      <div className="detail-pane__header">
        <div className="detail-pane__icon">
          <Icon size={18} />
        </div>
        <div>
          <div className="detail-pane__title">{title}</div>
          {subtitle ? <div className="detail-pane__subtitle">{subtitle}</div> : null}
        </div>
      </div>
      <div>{children}</div>
    </div>
  )
}

export function DetailField({ label, value }: { label: string; value?: ReactNode }) {
  return (
    <div className="detail-field">
      <div className="detail-field__label">{label}</div>
      <div className="detail-field__value">{value ?? '—'}</div>
    </div>
  )
}
